import { Box, VStack } from '@chakra-ui/react';
import type { InboxThread } from './types';
import { ThreadItem } from './ThreadItem';

type Props = {
  threads: InboxThread[];
  activeThreadId: string | null;
  onSelectThread: (id: string) => void;
};

export const ThreadList = ({ threads, activeThreadId, onSelectThread }: Props) => {
  return (
    <Box overflow="auto" h="calc(100% - 110px)">
      <VStack spacing="0" align="stretch">
        {threads.map((t) => (
          <ThreadItem
            key={t.id}
            thread={t}
            isActive={activeThreadId === t.id}
            onClick={() => onSelectThread(t.id)}
          />
        ))}
      </VStack>
    </Box>
  );
};
